import { type IWidgetAdvancedOption } from '../../../../Widget.ts';
import { type IWidgetAdvancedOptionValue } from '../form/createAdvancedSelectValueSchema.ts';
import { type IAdvancedSelectWidget } from '../IAdvancedSelectWidget.ts';

/**
 * Helper per calcolare il valore univoco dell’opzione
 */
export const getUniqueOptionValue = (
  widget: IAdvancedSelectWidget,
  option: IWidgetAdvancedOption,
) => {
  const uniqueValue = option.values?.[widget.uniqueValueColumnId];
  if (!uniqueValue) {
    console.error(
      `L'opzione non ha un valore per la colonna uniqueValueColumnId: ${widget.uniqueValueColumnId}`,
    );
    return '';
  }

  return String(uniqueValue);
};

export const getUniqueSelectedOptionValue = (
  widget: IAdvancedSelectWidget,
  optionValue: IWidgetAdvancedOptionValue,
) => {
  const uniqueValue = optionValue?.[widget.uniqueValueColumnId];
  if (!uniqueValue) {
    console.warn(
      `L'opzione selezionata non ha un valore per la colonna uniqueValueColumnId: ${widget.uniqueValueColumnId}`,
    );
    return '';
  }

  return String(uniqueValue);
};
